import React, { useMemo } from 'react';
import styled from '@tanium/react-emotion';
import { Icon } from '@tanium/react-graphics';
import { useTheme } from '@tanium/react-theme-context';

export interface Props {
  backgroundColor?: string;
  iconColor?: string;
  innerRadius?: number;
  icon?: Icon;
  outerRadius?: number;
  omitSvgElement?: boolean;
  className?: string;
}

const Svg = styled('svg')({ overflow: 'visible' });

export function CircleIcon({
  icon: IconComponent,
  outerRadius = 24,
  backgroundColor,
  iconColor,
  innerRadius = outerRadius * Math.sin(Math.PI / 4),
  omitSvgElement,
  className,
}: Props) {
  const outerDiameter = 2 * outerRadius;
  const innerDiameter = 2 * innerRadius;
  const innerMargin = outerRadius - innerRadius;

  const { colors } = useTheme();

  const groupStyle = useMemo(
    () => ({
      ...(iconColor && { color: iconColor }),
    }),
    [iconColor],
  );

  const content = (
    <>
      <circle
        cx={outerRadius}
        cy={outerRadius}
        r={outerRadius}
        fill={backgroundColor || colors.background}
      />
      {IconComponent && (
        <g transform={`translate(${innerMargin}, ${innerMargin})`} style={groupStyle}>
          <IconComponent height={innerDiameter} width={innerDiameter} />
        </g>
      )}
    </>
  );

  return omitSvgElement ? (
    content
  ) : (
    <Svg height={outerDiameter} width={outerDiameter} className={className} focusable={false}>
      {content}
    </Svg>
  );
}
